<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-no-padding">
                <form class="form">
                    <div class="form-row row">
                        <label class="col-12">{{ $t('plans.form.label') }}</label>
                        <input ref="label" type="text" v-model="label" class="form-input col-12"/>
                    </div>
                </form>
            </div>
        </div>
        <Toolbar class="p-4">
            <Btn class="primary" @click.native.stop="valid">
                {{ $t('global.save') }}
            </Btn>
            <Btn @click.native.stop="cancel">
                {{ $t('global.cancel') }}
            </Btn>
        </Toolbar>
    </div>

</template>

<script>
    import Toolbar from '@/components/ui/Toolbar';
    import AddressField from '@/components/ui/fields/AddressField';
    import Btn from "@/components/ui/Button";
    import MiniMap from '@/components/plans/map/MiniMap';

    export default {
        components: {
            Toolbar,
            Btn,
            MiniMap

        },
        data () {
            return {
                label: '',
                obj: null,
                editMode: false
            }
        },
        methods: {
            resetForm: function(){
                this.label = '';
            },
            cancel: function(){
                this.resetForm();
                this.$emit('close','add','group');
            },
            valid: function(){
                if(this.editMode){
                    this.obj.name = this.label;
                    this.$emit('editGroup',this.obj);
                }
                else {
                    var obj = {
                        name: this.label
                    }

                    this.$emit('addGroup', obj);
                }
                //this.resetForm();
            },
            edit: function(edit,obj){
                if(edit == null){
                    edit = false;
                }
                this.editMode = edit;
                if(obj != null) {
                    this.obj = obj;
                    this.label = obj.name;
                }
                if(!edit){
                    this.$refs.label.focus();
                }
            }
        },
        name: '',
        props: ['parent'],
    }
</script>

<style lang="scss" scoped>

</style>